// TODO: move to @xanadu/ui-shared
const refreshCacheAndReload = () => {
  // eslint-disable-next-line no-console
  console.log('Clearing cache and hard reloading...');
  if (window.caches) {
    // Service worker cache should be cleared with caches.delete()
    window.caches.keys().then(async (names) => {
      await Promise.all(names.map(name => caches.delete(name)));
    });
  }

  // delete browser cache and hard reload
  window.location.reload();
};

export default refreshCacheAndReload;